// Step 1 - Basic Info Step Component
import React from "react";
import { Grid, Typography } from "@mui/material";
import TextInputComponent from "../../ui/TextInputComponent";
import SelectInputComponent from "../../ui/SelectInputComponent";
import ButtonComponent from "../../ui/ButtonComponent";


const BasicInfoStep = ({ formData = {}, errors, handleChange, uploadingBanner, handleFileChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <SelectInputComponent
          label="Event Type"
          value={formData.eventType}
          onChange={handleChange("eventType")}
          options={[
            { label: "Annual Fundraiser", value: "Annual Fundraiser" },
            { label: "Peer to Peer Fundraiser", value: "Peer to Peer Fundraiser" },
            { label: "One Time Fundraiser", value: "One Time Fundraiser" },
            { label: "Appreciation Event", value: "Appreciation Event" },
            { label: "Charitable Event", value: "Charitable Event" },
          ]}
          error={errors.eventType}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInputComponent
          label="Event ID"
          value={formData.eventId}
          onChange={handleChange("eventId")}
          error={errors.eventId}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInputComponent
          label="Event Name"
          value={formData.eventName}
          onChange={handleChange("eventName")}
          error={errors.eventName}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInputComponent
          label="Fundraising Goal"
          value={formData.fundraisingGoal}
          onChange={handleChange("fundraisingGoal")}
        />
      </Grid>
      <Grid item xs={12}>
        <ButtonComponent
            type="secondary"
            label={uploadingBanner ? "Uploading..." : "Upload Banner Image"}
            onClick={() => document.getElementById("bannerUploadInput").click()}
            disabled={uploadingBanner || !formData.eventId}
        />
        <input
            id="bannerUploadInput"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleFileChange}
        />
         {!formData.eventId && (
                  <Typography variant="caption" 
                  color="error" 
                  sx={{ display: "block", marginTop: 1 }}
                  >              
                    Please enter Event ID before uploading.
                  </Typography>
                )}
              </Grid>

    </Grid>
  );
};

export default BasicInfoStep;
